import React, { useCallback, useState } from 'react';

import { App, Modal, Radio, Input, Button } from 'antd';

import type { IRating } from 'v2/services/showcase';

import { useRateProducer } from '../../useRateProducer';

interface IProps {
  open: boolean;
  onClose: any;
  producerId: any;
}

const INITIAL_RATING: IRating = {
  training_support: '1',
  material_product: '1',
  disponibility: '1',
  awards: '1',
  respect: '1',
  comment: ''
};

const ModalEvaluation: React.FC<IProps> = ({ open, onClose, producerId }) => {
  const { message } = App.useApp();
  const [rating, setRating] = useState<IRating>({ ...INITIAL_RATING });

  const { rateProducer, isRateProducerPending } = useRateProducer(producerId);

  const handleChange = useCallback((name: string, value: any) => {
    setRating(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async () => {
    try {
      await rateProducer(rating);
      message.success('Avaliação feita com sucesso!');
      onClose();
    } catch {
      message.error('Não foi possível enviar a avaliação.');
    }
  }, [onClose, rating, rateProducer, message]);

  return (
    <Modal
      title='Avaliar Produtor'
      open={open}
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={onClose}>
            Cancelar
          </Button>
          <Button
            loading={isRateProducerPending}
            type='primary'
            disabled={rating.comment.length === 0 || isRateProducerPending}
            onClick={handleSubmit}
          >
            Enviar
          </Button>
        </div>
      }
      closable={true}
      width='auto'
      onCancel={onClose}
      centered
    >
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between gap-2'>
          <span>Treinamento e Apoio</span>
          <Radio.Group value={rating.training_support} onChange={e => handleChange('training_support', e.target.value)}>
            <Radio value='1'>1</Radio>
            <Radio value='2'>2</Radio>
            <Radio value='3'>3</Radio>
            <Radio value='4'>4</Radio>
            <Radio value='5'>5</Radio>
          </Radio.Group>
        </div>
        <div className='flex items-center justify-between gap-2'>
          <span>Material/Informações sobre o Produto</span>
          <Radio.Group value={rating.material_product} onChange={e => handleChange('material_product', e.target.value)}>
            <Radio value='1'>1</Radio>
            <Radio value='2'>2</Radio>
            <Radio value='3'>3</Radio>
            <Radio value='4'>4</Radio>
            <Radio value='5'>5</Radio>
          </Radio.Group>
        </div>
        <div className='flex items-center justify-between gap-2'>
          <span>Disponibilidade e Suporte ao Afiliado</span>
          <Radio.Group value={rating.disponibility} onChange={e => handleChange('disponibility', e.target.value)}>
            <Radio value='1'>1</Radio>
            <Radio value='2'>2</Radio>
            <Radio value='3'>3</Radio>
            <Radio value='4'>4</Radio>
            <Radio value='5'>5</Radio>
          </Radio.Group>
        </div>
        <div className='flex items-center justify-between gap-2'>
          <span>Premiações e Incentivos</span>
          <Radio.Group value={rating.awards} onChange={e => handleChange('awards', e.target.value)}>
            <Radio value='1'>1</Radio>
            <Radio value='2'>2</Radio>
            <Radio value='3'>3</Radio>
            <Radio value='4'>4</Radio>
            <Radio value='5'>5</Radio>
          </Radio.Group>
        </div>
        <div className='flex items-center justify-between gap-2'>
          <span>Ética e Respeito</span>
          <Radio.Group value={rating.respect} onChange={e => handleChange('respect', e.target.value)}>
            <Radio value='1'>1</Radio>
            <Radio value='2'>2</Radio>
            <Radio value='3'>3</Radio>
            <Radio value='4'>4</Radio>
            <Radio value='5'>5</Radio>
          </Radio.Group>
        </div>
        <div className='mt-4' />
        <div className='flex items-center justify-between'>
          <div className='w-full'>
            <label className='mb-1 block text-sm'>Adicione um comentário sobre esse produtor</label>
            <Input.TextArea value={rating.comment} rows={3} onChange={e => handleChange('comment', e.target.value)} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalEvaluation;
